import { render, staticRenderFns } from "./BaseUserDialogSelector.vue?vue&type=template&id=380cb87b"
import script from "./BaseUserDialogSelector.vue?vue&type=script&lang=js"
export * from "./BaseUserDialogSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports